module.exports = __webpack_public_path__ + "static/generic_main-5dda22f86e2f943476d41ce3b3307450.jpg";